import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { File } from '../../../../graphql/generated/graphql';
import { SPACING_REGULAR } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';

interface Props {
  file: Pick<File, 'originalFileName'> | null;
  className?: string;
}

const CreativeAttributeFileName = ({ file, className }: ClassAttributes<HTMLElement> & Props) => {
  const uploadedFile = file ? file : null;

  return (
    <Root className={className}>
      <FileTypographStyle>
        <Typography color="textSecondary" variant="caption" className="fileName">
          <FormattedMessage id="show_creation_page.submission.attribute_file_name.file_name" />
        </Typography>
      </FileTypographStyle>
      <FileName color="textPrimary" variant="caption">
        {uploadedFile ? uploadedFile.originalFileName : '-'}
      </FileName>
    </Root>
  );
};

const Root = styled('div')(flexibleLayoutContainer({ direction: 'row', alignItems: 'flex-start' }));

const FileTypographStyle = styled(Typography)({
  marginRight: SPACING_REGULAR,
});

const FileName = styled(Typography)({
  flex: 1,
  wordBreak: 'break-word',
});

export default CreativeAttributeFileName;
